export default {
  apiKey: "AIzaSyBO7GEeOhrMU_qUpH-fkHdRGaCq9e2L5JI",
  authDomain: "aeroware-644f3.firebaseapp.com",
  projectId: "aeroware-644f3",
  storageBucket: "aeroware-644f3.appspot.com",
  messagingSenderId: "13342078725",
  appId: "1:13342078725:web:f273b74a4925d0a852a96c",
  measurementId: "G-WJCQEBCERJ"
}